import type { Status } from '@/entities/user/model/userSchema';

export const STATUS_LABELS: Record<Status, string> = {
  ok: 'Действует',
  warn: 'Истекает',
  err: 'Просрочено',
  info: 'Назначено',
};

export const MEDICAL_STATUS_LABELS: Record<Status, string> = {
  ok: 'Пройден',
  warn: 'Истекает',
  err: 'Просрочен',
  info: 'Назначен',
};

export const REFERRAL_DOC_LABELS: Record<Status, string> = {
  ok: 'Сформировано',
  warn: 'Истекает',
  err: 'Данные неполные',
  info: 'Черновик',
};

export const STATUS_FILTER_OPTIONS = [
  { value: '', label: 'Все статусы' },
  { value: 'err', label: 'Просрочен' },
  { value: 'warn', label: 'Истекает' },
  { value: 'ok', label: 'Пройден' },
  { value: 'info', label: 'Назначен' },
] as const;
